export default {
  projectId: "",
  projectType: ""
}